import React from "react"
import AboutGallery from "../../components/nico/AboutGallery"
import AboutInfo from "../../components/nico/AboutInfo"
import AboutMap from "../../components/nico/AboutMap"
import AboutStaff from "../../components/nico/AboutStaff"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/nico/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const about = () => (
  <Layout>
    <SEO title={PAGE.title.about} siteTitle="nico" />
    <HeadingL title={PAGE.title.about} target="nico" />
    <AboutInfo />
    <AboutMap />
    <AboutStaff />
    <AboutGallery />
  </Layout>
)

export default about
